module.exports = __webpack_public_path__ + "static/img/empty.a5c85472.svg";